<section class="panel mt-5">
    <div class="row">
        <div class="col col-md-6">
            <header class="panel-heading">
                <h4 class="panel-title text-primary">Answers</h4>
            </header>
        </div>
    </div>

    <div class="card" *ngIf="!currentQuestionAnswers || currentQuestionAnswers.length == 0">
        <div class="card-body bg-primary">
            <h4>Important</h4>
            <p>You must add Answers to any Question that has been added to a Question Bank. Click Edit to add new questions and remember to Save before leaving the question.</p>
        </div>
    </div>

    <div class="panel-body mb-4" *ngIf="isEditMode">
        <div class="table-responsive">
            <form (submit)="addQuestionAnswer()" [formGroup]="addQuestionAnswerFormGroup">
                <table class="table mb-0 add-question">
                    <thead>
                        <tr>
                            <th></th>
                            <th width="20%" class="text-primary">Title</th>
                            <th width="13%" class="text-primary">Score</th>
                            <th width="50%" class="text-primary">Comment</th>
                            <th width="13%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>New</td>
                            <td>
                                <input type="text" class="form-control" formControlName="title" list="optionList" />
                                <datalist id="optionList">
                                    <option value="Yes">
                                    <option value="No">
                                    <option value="Unknown">
                                    <option value="N/A">
                                </datalist>
                            </td>
                            <td>
                                <input type="number" class="form-control" formControlName="score" min="0" max="2"/>
                            </td>
                            <td>
                                <input type="text" class="form-control" formControlName="comment" />
                            </td>
                            <td class="actions">
                                <button class="btn btn-success" type="submit">Add</button>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td></td>
                            <td></td>
                            <td colspan="2" class="text-info">
                                Scoring: Best Option = 0, Worst Option = 2, Medium = 1
                            </td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </form>
        </div>
    </div>



    <div class="panel-body" *ngIf="currentQuestionAnswers && currentQuestionAnswers.length > 0">
        <div class="table-responsive">
            <table class="table table-hover mb-none">
                <thead>
                    <tr>
                        <th>#</th>
                        <th width="20%">Title</th>
                        <th width="13%">Score</th>
                        <th width="50%">Comment</th>
                        <th width="13%" class="text-center">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let currentQuestionAnswer of currentQuestionAnswers;index as i">
                        <td>{{i+1}}</td>
                        <td>
                            <span *ngIf="!isEditMode">{{currentQuestionAnswer.title}}</span>
                            <span *ngIf="isEditMode"><input class="form-control" type="text" [(ngModel)]="currentQuestionAnswer.title" (blur)="updateQuestionAnswers()" /></span>
                        </td>
                        <td>
                            <span *ngIf="!isEditMode">
                                <span class="badge bg-success" *ngIf="currentQuestionAnswer.score==0">{{currentQuestionAnswer.score}}</span>
                                <span class="badge bg-warning" *ngIf="currentQuestionAnswer.score==1">{{currentQuestionAnswer.score}}</span>
                                <span class="badge bg-danger" *ngIf="currentQuestionAnswer.score>=2">{{currentQuestionAnswer.score}}</span>
                            </span>
                            <span *ngIf="isEditMode"><input class="form-control" type="number" [(ngModel)]="currentQuestionAnswer.score" (blur)="updateQuestionAnswers()" /></span>
                        </td>
                        <td>
                            <span *ngIf="!isEditMode">{{currentQuestionAnswer.comment}}</span>
                            <span *ngIf="isEditMode"><input class="form-control" type="text" [(ngModel)]="currentQuestionAnswer.comment" (blur)="updateQuestionAnswers()" /></span>
                        </td>
                        <td class="actions text-center" *ngIf="isEditMode">
                            <a *ngIf="isEditMode" class="mb-1 mt-1 mr-2 text-primary" (click)="deleteQuestionAnswer(i)"><i class="fas fa-trash"></i></a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</section>
